import axios from "../api/axios";
import useAuth from "./useAuth";

const useRefreshToken = () => {
  const { auth, setAuth } = useAuth();

  const refresh = async () => {
    const response = await axios.get("/api/v1/auth/refresh", {
      headers: { Authorization: `Bearer ${auth?.refreshToken}` },
      withCredentials: true,
    });
    setAuth((prev) => {
      return {
        ...prev,
        accessToken: response.data?.data?.accessToken,
      };
    });
    return response.data?.data?.accessToken;
  };
  return refresh;
};

export default useRefreshToken;
